import { render, staticRenderFns } from "./seekAdviceFrom.vue?vue&type=template&id=6f026734"
import script from "./seekAdviceFrom.vue?vue&type=script&lang=js"
export * from "./seekAdviceFrom.vue?vue&type=script&lang=js"
import style0 from "./seekAdviceFrom.vue?vue&type=style&index=0&id=6f026734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports